module.exports = __webpack_public_path__ + "img/selectOption.4483580c.svg";